/**
 * Layout tokens shared by the CSML visual builder, so spacing, node size and
 * snapping all line up on one grid.
 */

export const GRID = 16;
export const NODE_WIDTH = 256;
export const NODE_MIN_HEIGHT = 80;
export const TOPBAR_H = 48;
export const PALETTE_W = 240;
export const PALETTE_RAIL_W = 48;
export const PANEL_W = 320;
export const COL_GAP = 96;
export const ROW_GAP = 48;
export const FLOAT_INSET = 12;

export const snapToGrid = value => Math.round(value / GRID) * GRID;
